/* eslint-disable react/no-unknown-property */
import clsx from 'clsx'
import { ErrorName, validateName } from 'features/campaigns/utils'
import { useEffect, useId, useRef, useState } from 'react'
import { modal, typo } from 'shared/styles'
import { LoadingButton, StackIcon } from 'shared/ui'
import { ControlledDialog } from 'shared/ui/Dialog'

import css from './CreateModal.module.scss'

export function CreateModal({
	amount = 0,
	isLoading = false,
	onRequestClose,
	onSubmit,
	open
}: {
	amount?: number
	isLoading?: boolean
	onRequestClose: () => void
	onSubmit: (name: string) => Promise<any>
	open: boolean
}) {
	const id = useId()
	const ref = useRef<HTMLFormElement | null>(null)

	let lead = 'to set up the sequence of actions'
	const [error, setError] = useState(ErrorName.EmptyName)

	if (amount) {
		lead += ` for ${amount} contacts`
	}

	useEffect(() => {
		if (!open) {
			ref.current?.reset()
		}
	}, [open])

	return (
		<ControlledDialog
			className={css.wrapper}
			onRequestClose={onRequestClose}
			open={open}
			rootClassName={css.root}
		>
			<button className={modal.close} onClick={onRequestClose} type='button'>
				<StackIcon icon='close' stroke='currentcolor' width={14} />
			</button>

			<h2 className={typo.subtitle}>
				<label htmlFor={id}>Name your campaign</label>
			</h2>

			<p className={clsx(typo.mediumBody, css.lead)}>{lead}</p>

			<form
				className={css.form}
				onReset={() => setError(ErrorName.EmptyName)}
				onSubmit={async event => {
					event.preventDefault()

					const form = event.currentTarget
					const value = (form.name as unknown as HTMLInputElement).value

					await onSubmit(value)

					form.reset()
					onRequestClose()
				}}
				ref={ref}
			>
				<input
					aria-errormessage={`${id}-error`}
					autoComplete='off'
					// @ts-ignore eslint-disable-next-line Recheck in React 19
					autofocus='true'
					className={css.input}
					id={id}
					name='name'
					onChange={event => {
						let value = event.currentTarget.value
						value = value.trim()
						setError(validateName(value))
					}}
				/>

				<LoadingButton
					className={css.submit}
					disabled={error !== ErrorName.None}
					isLoading={isLoading}
					type='submit'
				>
					Create
				</LoadingButton>

				<p className={css.error} id={`${id}-error`}>
					{validateName.texts[error]}
				</p>
			</form>
		</ControlledDialog>
	)
}
